import { getDefaultValue } from "@draftkings/sportsbook-common-utils";
export const sortParticipants = (event) => getDefaultValue(event.participants, [])
    .filter((p) => p.type === "Team")
    .sort((a, b) => {
    if (a.sortOrder && b.sortOrder) {
        return a.sortOrder - b.sortOrder;
    }
    return 0;
});
//# sourceMappingURL=sortParticipants.js.map